module.exports = __webpack_public_path__ + "img/super-bonus-popup.aa2e9064.gif";